import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    vbpx: any;
  }
}
export function VibePx() {
  useEffect(() => {
    // Create and append the Vibe pixel script
    const script = document.createElement('script');
    script.async = true;
    script.innerHTML = `
      !function(v,i,b,e,c,o){if(!v[c]){var s=v[c]=function(){s.process?s.process.apply(s,arguments):s.queue.push(arguments)};s.queue=[],s.b=1*new Date;var t=i.createElement(b);t.async=!0,t.src=e;var n=i.getElementsByTagName(b)[0];n.parentNode.insertBefore(t,n)}}(window,document,"script","https://s.vibe.co/vbpx.js","vbpx");
      vbpx('init','H3AR0h');
      vbpx('event', 'page_view');
    `;
    document.head.appendChild(script);
    // Cleanup function
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return null;
}